import { createContext, useContext } from 'react';
import { ChainIds } from '@sovryn/ethers-provider';
import { noop } from '@sovryn/ui';
export var SendFlowStep;
(function (SendFlowStep) {
    SendFlowStep[SendFlowStep["INITIAL"] = 0] = "INITIAL";
    SendFlowStep[SendFlowStep["MAIN"] = 1] = "MAIN";
    SendFlowStep[SendFlowStep["AMOUNT"] = 2] = "AMOUNT";
    SendFlowStep[SendFlowStep["REVIEW"] = 3] = "REVIEW";
    SendFlowStep[SendFlowStep["PROCESSING"] = 4] = "PROCESSING";
    SendFlowStep[SendFlowStep["COMPLETED"] = 5] = "COMPLETED";
})(SendFlowStep || (SendFlowStep = {}));
export var AddressValidationState;
(function (AddressValidationState) {
    AddressValidationState["NONE"] = "NONE";
    AddressValidationState["LOADING"] = "LOADING";
    AddressValidationState["VALID"] = "VALID";
    AddressValidationState["INVALID"] = "INVALID";
})(AddressValidationState || (AddressValidationState = {}));
export const defaultValue = {
    step: SendFlowStep.INITIAL,
    amount: '',
    receiver: '',
    chain: ChainIds.MAINNET,
    asset: undefined,
    set: noop,
    chainId: undefined,
    token: undefined,
};
export const SendFlowContext = createContext(defaultValue);
export const useSendFlowContext = () => {
    return useContext(SendFlowContext);
};
